export function getRealmFromIssuer(iss: string): string | null {
  const match = iss.match(/\/realms\/([^/]+)/);
  return match ? match[1] : null;
}
